import { getAllData, updateDocumentByID } from 'apis/customApiHandler';
import axios from 'axios';
import Modal from 'components/Modal';
import { TableHeader } from 'components/retread-request/TableHeader';
import { ViewRethreadList } from 'components/retread-request/ViewRethreadList';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { Button } from 'styled';
import { TD, TH } from 'styled/table';

const RetreadApproval = () => {
  const { requestId } = useParams(); 
  const [approvedData, setApprovedData] = useState(null);
  const[rejectedData,setRejectedData]=useState(null);
  const [approvalReason, setApprovalReason] = useState("");
  const[rejectionReason,setRejectionReason]=useState("");
  const [selectedTyres, setSelectedTyres] = useState({});
  const [approvalRemarks, setApprovalRemarks] = useState("");

  // alert("Fetching Data")
  const { data: requestData, isLoading, isError,refetch } = useQuery(
    [`/retread-request/${requestId}`, requestId],
    () => getAllData(`/retread-request/${requestId}`)
  );

  let status=requestData?.data?.status

  const updateApprovalRecord = async (id, status, data = {}) => {
    const tyresPayload = requestData.data.tyres.map((tyre) => ({
        _id: tyre._id,
        approvedForRetread: !!selectedTyres[tyre._id],
    }));

    const myPromise = updateDocumentByID("retread-request/approve", requestId, {
        status: status,
        tyres: tyresPayload,
        ...(data && { ...data }),
    });

    toast.promise(myPromise, {
        loading: "Updating your request",
        success: (dt) => {
            refetch();
            return 'Request Approved';
        },
        error: (err) => {
          console.log('err--',err);
            return (
                err?.response?.data.error ||
                err?.response?.data.message ||
                err?.message ||
                "Something went wrong"
            );
        },
    });
};

        const handleCheckboxChange = (tyreId, checked) => {
          setSelectedTyres((prev) => ({
            ...prev,
            [tyreId]: checked,
          }));
        };

          if (!requestData) {
            return <p>Loading...</p>; 
          }

  return (
    <div className="mx-10 my-2">
      <div
        style={{ color: 'black' }}
        className="justify-center items-center sm:w-full md:w-3/4 mx-auto text-center mt-10 font-medium text-gray-400 border border-gray-200 border-1 p-2  h-[100%] flex flex-col gap-auto"
      >
        <div className="mb-2">
          Request to retread <b>{requestData?.data?.tyres?.length}</b> tyre(s) has been created by <b>{requestData?.data?.createdBy?.name}</b> for 
          <b> { requestData?.data?.fleet?.fleetName}</b> - <b>{requestData?.data?.hub?.hubName}</b> to <b>{requestData?.data?.vendor?.vendorName}</b>. Please find the details below:
        </div>
        <br />


        <div className="w-full h-full overflow-x-auto sm:-mx-6 lg:-mx-8">
          <table className="divide-y divide-gray-200 align-center justify-center mx-auto border border-gray-200 border-1 h-full overflow-x-scroll">
            <thead className="bg-gray-50">
              <tr>
                <TH></TH>
                <TH>S.N.</TH>
                <TH>Stencil No</TH>
                <TH>NSD</TH>
                <TH>Brand</TH>
                <TH>Tyre Size</TH>
                <TH>KM Travelled</TH>
                <TH>Current Status</TH>
                <TH>Actions</TH>
                <TH>Cost</TH>
              </tr>
            </thead>
            <tbody>
              {requestData?.data?.tyres?.map((tyre, index) => (
                <tr key={tyre._id}>
                  <TD className="text-center">
                    <input
                      type="checkbox"
                      checked={!!selectedTyres[tyre._id]}
                      onChange={(e) => handleCheckboxChange(tyre._id, e.target.checked)}
                    />
                  </TD>
                  <TD>{index + 1}</TD>
                  <TD>{tyre.stencilNo}</TD>
                  <TD>{tyre.averageNSD}</TD>
                  <TD>{tyre.brand}</TD>
                  <TD>{tyre.tyreSize}</TD>
                  <TD>{tyre.totalKillometerTravelled}</TD>
                  <TD>{tyre.oldStatus}</TD>
                  <TD>{tyre?.approvedForRetread ? tyre.rejectedAfterReceiving ? "Rejected After Retread" : "Approved" : "Not Approved"}</TD>
                  <TD>{tyre.estimatedCost}</TD>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {status!=="Requested"?

<div className="text-center my-5 font-medium text-gray-600">
<p>The Request <b>{requestData?.data?.requestNo}</b>'s current status is <b>{requestData?.data?.status}</b>.</p>
</div>


:

<div>

        <div className="mt-5 w-full">
          <textarea
            className="w-[600px] rounded-md py-2 px-3 my-2 text-gray-500 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 border border-gray-300"
            placeholder="Enter approval remarks (max 150 chars)"
            maxLength={150}
            value={approvalRemarks}
            onChange={(e) => setApprovalRemarks(e.target.value)}
          />
        </div>

        
        
        <div className="flex gap-10 mt-5">
          <Button
            disabled={!Object.values(selectedTyres).some((checked) => checked) || !approvalRemarks.trim()}
            className="p-2 m-1 rounded-md bg-green-500 hover:bg-green-600 text-white"
            onClick={async () => {
              await updateApprovalRecord(approvedData?._id, "APPROVED", {
                approvalRemarks,
              });
              setApprovalRemarks("");
              setApprovedData(null);
            }}
          >
            Approve
          </Button>
        </div>

        </div>

          }
        
      </div>

      </div>

  );
};

export default RetreadApproval;